import { render, staticRenderFns } from "./searchpage.vue?vue&type=template&id=8c71b7b0&scoped=true"
import script from "./searchpage.vue?vue&type=script&lang=js"
export * from "./searchpage.vue?vue&type=script&lang=js"
import style0 from "./searchpage.vue?vue&type=style&index=0&id=8c71b7b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c71b7b0",
  null
  
)

export default component.exports